import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import bg from '../../assets/images/signin-background.jpg';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '100vh',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundImage: `url(${bg})`,
    padding: '0 15px',
  },
  content: {
    margin: 'auto',
  },
  footer: {
    width: '100%',
    maxWidth: 689,
    padding: '53px 0',
    margin: '0 auto',
    color:'white !important'
  },
}));

export default useStyles;
